import React, { useContext, useEffect } from 'react';
import { ContentLoader, withLocalization } from '@adac-mp/components';
import { VignetteContext, countryUrlMap, getVignetteCheckoutProcessCollection } from '@adac-mp/shared';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { VignetteCheckout } from '../../components/vignette/vignetteCheckout';

const Checkout = () => {
	const countryUrl = countryUrlMap[14];
	const { lang } = useParams();
	const {
		error: contentFulError,
		data,
		loading,
	} = useQuery(getVignetteCheckoutProcessCollection, {
		variables: { lang: lang ?? 'de', slug: countryUrl },
	});

	const { updateContentfulLabels } = useContext(VignetteContext);
	useEffect(() => {
		if (!contentFulError) {
			updateContentfulLabels(data?.vignettenCheckoutCollection.items[0]);
		}
	}, [data]);

	return (
		<>
			{loading ? (
				<ContentLoader isLoading hasPortal={false} />
			) : (
				<VignetteCheckout
					hasMultipleCountries
					hasCategories
					hasSpecialPlates
					countryCode={14}
					tracking={{
						funnel_view: {
							label: 'Jetzt bestellen',
							element: 'Checkout',
							trackOnce: true,
						},
					}}
				/>
			)}
		</>
	);
};

export const VignetteCheckoutSchweiz = withLocalization(Checkout);
